export default __webpack_public_path__ + "static/media/040-washing dishes.076ed1fa.svg";